import React from 'react'
import { Banner } from './style'

const BannerFlotante1 = () => {
  return (    
    <Banner id="intro-placement">
      <button type="button" id="close-intro-btn">X</button>
      <div id='div-gpt-ad-intro'></div>
    </Banner>
  )
}

export default BannerFlotante1